import { render, staticRenderFns } from "./charpter-wrap.vue?vue&type=template&id=7b3f4cd3&scoped=true&"
import script from "./charpter-wrap.vue?vue&type=script&lang=js&"
export * from "./charpter-wrap.vue?vue&type=script&lang=js&"
import style0 from "./charpter-wrap.vue?vue&type=style&index=0&id=7b3f4cd3&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3f4cd3",
  null
  
)

export default component.exports